import React, { Component } from 'react';
import {
  Button,
  ButtonDropdown,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import './SaveChanges.css';

class SaveChanges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      publishOpen: false,
      showRestoreModal: false
    };
  }

  toggleBodyClass() {
    const bodyClassList = document.body.classList;

    if (this.props.modified) {
      bodyClassList.add('changes-bar-open');
    } else {
      bodyClassList.remove('changes-bar-open');
    }
  }

  togglePublish() {
    this.setState({
      publishOpen: !this.state.publishOpen
    });
  }

  publishStore(environment) {
    this.props.publish(
      this.props.activeStoreId,
      this.props.activeStore,
      environment
    );
  }

  render() {
    const { modified } = this.props;
    return (
      <div className={`save-changes-wrapper active`}>
        <Container className="button-panel">
          {modified && (
            <Button color="link" onClick={this.props.loadStore}>
              Discard changes...
            </Button>
          )}

          <ButtonDropdown
            isOpen={this.state.publishOpen}
            toggle={() => {
              this.togglePublish();
            }}
          >
            <DropdownToggle caret color={'success'}>
              Save and publish to...
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() => {
                  this.publishStore('test');
                }}
              >
                Test
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  this.publishStore('production');
                }}
              >
                Production
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </Container>
      </div>
    );
  }
}

export default SaveChanges;



// WEBPACK FOOTER //
// ./src/components/SaveChanges/SaveChanges.js